// The Android app (ui/mobile) runs this site in a WebView and adds what the WebView
// can't do on its own. Its native side is the Yatayat plugin
// (ui/mobile/android/.../YatayatPlugin.java), which Capacitor puts on
// window.Capacitor.Plugins without any package on our side.

export interface YatayatApp {
  /** Opens Android's print dialog for the page. */
  print(): Promise<void>;
}

type Capacitor = { isNativePlatform?: () => boolean; Plugins?: { Yatayat?: YatayatApp } };

function plugin(): YatayatApp | undefined {
  if (typeof window === "undefined") return undefined;
  const cap = (window as { Capacitor?: Capacitor }).Capacitor;

  return cap?.isNativePlatform?.() ? cap.Plugins?.Yatayat : undefined;
}

/** Whether the site is running inside the Android app. */
export const inApp = () => plugin() !== undefined;

/** Prints the page: the browser's dialog, or Android's in the app, where window.print() does nothing. */
export function printPage(): void {
  const app = plugin();
  if (app) void app.print();
  else window.print();
}
